import script from "./AdminBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBar.vue?vue&type=script&setup=true&lang=ts"

import "./AdminBar.vue?vue&type=style&index=0&id=358e4954&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358e4954"]])

export default __exports__